import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface QuickLink {
  title: string;
  description: string;
  href: string;
  icon: string;
}

interface QuickLinksProps {
  links: QuickLink[];
}

export default function QuickLinks({ links }: QuickLinksProps) {
  return (
    <div className="bg-cornsilk border border-border rounded-lg p-8 mb-12">
      <h2 className="font-headline text-2xl font-bold text-primary mb-6 text-center">
        Quick Access
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {links.map((link, index) => (
          <Link
            key={index}
            href={link.href}
            className="bg-background border border-border rounded-lg p-4 hover:shadow-brand transition-brand group"
          >
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-brand">
                <Icon
                  name={link.icon as any}
                  size={20}
                  className="text-primary"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-body font-semibold text-foreground mb-1 group-hover:text-primary transition-brand">
                  {link.title}
                </h3>
                <p className="font-body text-sm text-muted-foreground line-clamp-2">
                  {link.description}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}